// removed by extract-text-webpack-plugin
module.exports = {"main":"main__main___3r9tt"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/main.css
// module id = 655
// module chunks = 0